import { defaultApi } from '@/plugins/api/defaultApi'
import store from '@/store'

export default {
  name: 'agreement',
  namespaced: true,
  state: {
    contractCurrent: null,
    terms: [],
    status: null,
  },
  mutations: {
    setTerms(state, terms) {
      state.terms = terms
    },
    setStatus(state, status) {
      state.status = status
    },
    setContractCurrent(state, contractCurrent) {
      state.contractCurrent = contractCurrent
    },
  },
  actions: {
    async getAgreements({ commit }) {
      const { data } = await defaultApi.getAgreements()
      commit('setAgreements', data)
      return data
    },
    async getAgreementStatus({ commit }) {
      const { data } = await defaultApi.getAgreementsStatus()
      commit('setStatus', data.allRequiredTermsAgreed)
      return data.allRequiredTermsAgreed
    },

    async getKcsTerms({ dispatch, commit }) {



      const { data } = await defaultApi.getKcsTerms()

      console.log('data : ', data);
      return data
        //const originTerms = await dispatch('getTerms')
  /*
        // 그대로 넘긴다
        commit('setTerms', originTerms)
        return originTerms

        */
    },

    async getServiceTerms({ dispatch, commit }) {

    //if( !store.state.organi)

      // 아래와 같이 수정 필요 by sean

      //////////////////////////////////////////////
      // 모든 약관을 가져온다
      //////////////////////////////////////////////

      const params = { organizationCode : store.state.myfinbiz.organization?.code }; // 원하는 파라미터를 여기에 설정
      const originTerms = await dispatch('getTermsByParam', params);
      //const originTerms = await dispatch('getTerms')

      // 그대로 넘긴다
      commit('setTerms', originTerms)
      return originTerms

/*

      // 기관 약관 중 필수
      const organizationTerms = originTerms
        .filter(
          (term) =>
            term.isRequired
        )
        .map((obj) => ({ ...obj, isAgreed: false, isOrganization: true }))

      // 기관 약관 중 선택
      const organizationTermsOptional = originTerms.find(
        (term) =>
          !term.isRequired
      )
      if (organizationTermsOptional) {
        organizationTermsOptional.isAgreed = false
        organizationTermsOptional.isOrganization = true

      }



      //////////////////////////////////////////////
      // 금융 약관
      //////////////////////////////////////////////
      const paramsFin = { serviceCode : 'early_payment' }; // 원하는 파라미터를 여기에 설정
      const originTermsFin = await dispatch('getTermsByParam', paramsFin);


      // 필수
      const finTerms = originTermsFin
        .filter(
          (term) =>
            term.isRequired === true
        )
        .map((obj) => ({ ...obj, isAgreed: false }))

      // 옵션
      const finTermsOptional = originTermsFin.find(
        (term) =>
          !term.isRequired
        )
      if (finTermsOptional) {
        finTermsOptional.isAgreed = false
 
      }


     
      const mergeTerms = organizationTerms.concat(finTerms)

      commit('setTerms', mergeTerms)


      console.log('mergeTerms = ', mergeTerms)
      return mergeTerms

      */
    },
    async getContractTerms({}) {
      const { data } = await defaultApi.getContractTerms()
      return data
    },
    async getContractTermsCode({}, { code }) {
      const { data } = await defaultApi.getContractTermsCode({ code })
      return data
    },
    async getContractCurrent({ commit }) {
      const { data } = await defaultApi.getContractCurrent()
      commit('setContractCurrent', data)
      return data
    },
    async getContractAgreements() {
      const { data } = await defaultApi.getContractAgreements()
      return data
    },
    async addContractAgreements({}, contract) {
      const { data } = await defaultApi.postContractAgreements(contract)
      return data
    },
    async getTerms({}) {
      const { data } = await defaultApi.getTerms()
      return data
    },
    async getTermsByCode(code, param) {
      const { data } = await defaultApi.getTermsByCode(code, param)
      return data
    },
    async getTermsByParam({},param) {
      const { data } = await defaultApi.getTermsByParam(param)
      return data
    },
    async postServiceTermsAgreements({}, terms) {
      let sendTerms = []
      const sendContractTerms = []
      for (const t of terms) {
        if (t.isGeneratedByClient === false) {
          sendContractTerms.push(t)
        } else {
          sendTerms.push(t)
          if (t.childs) {
            sendTerms = sendTerms.concat(t.childs)
          }
        }
      }
      // 전송
      await defaultApi.postAgreements(sendTerms)
      for (const c of sendContractTerms) {
        if (c.isAgreed === true) {
          await defaultApi.postContractTermAgree(c)
        } else {
          await defaultApi.postContractTermDisagree(c)
        }
      }
    },
    async getTermsContentByCode({}, { code, date }) {
      const { data } = await defaultApi.getTermsContentByCode(code, { date })
      return data
    },
  },
}
